<template>
  <ForieLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <subPageBanner pageTitle="txt_urunler" />

  <div class="container-fuild">
    <div class="container">
      <div class="row product-list">
        <h1 class="mb-5 mt-5">
          {{
            this.$store.getters
              .getWordLocale("txt_urun_detay_h1")
              .replace(`{1}`, productName)
              .replace(`{2}`, companyName)
          }}
        </h1>
        <div class="col-12">
          <img :src="'https://cdn.turkishexporter.com.tr' + productImage" />
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild mt-5">
    <div class="container">
      <div class="row product-list">
        <div class="detail-product-item-title-box">
          <h6>{{ this.$store.getters.getWordLocale("txt_diger_urunler") }}</h6>
        </div>
        <div
          class="col-6 col-sm-6 col-md-4 col-lg-3"
          v-for="(product, pi) in otherProducts"
          :key="pi"
        >
          <router-link
            :to="
              '/' +
              this.$store.state.langCodeX +
              '/' +
              product.productLink +
              '/' +
              this.$store.state.singleCompanyUrlNameX
                .split(`-`)
                .slice(0, 3)
                .join(`-`) +
              '/' +
              this.$store.state.singleCompanyUrlCountryX +
              '/export-products'
            "
            v-on:click="changeProductView(product.id)"
            class="detail-product-item product-item"
          >
             <img
            @load="handleLoad"
            v-bind:class="{ loading: isLoading }"
            :src="'https://cdn.turkishexporter.com.tr' + product.image"
          />
            <small :title="product.fullTitle"> {{ product.title }}</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subPageBanner from "./components/SubPageBanner.vue";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";
import { mapState } from "vuex";

import helper from "./helper.js";
export default {
  computed: mapState({
    singleCompanyProductIdX: (state) => state.singleCompanyProductIdX,
  }),
  watch: {
    singleCompanyProductIdX(newVal) {
      if (newVal > 0) {
        this.changeProductView(this.$store.state.singleCompanyProductIdX);
        this.$store.state.singleCompanyProductIdX = 0;
      }
    },
  },
  components: {
    ForieLoader,
    TeLoader,
    subPageBanner,
  },
  data() {
    return {
          imageCount: 0,
      isLoading: true,
      showLoader: true,
      countryName: "",
      otherProducts: [],
      productImage: "",
      productName: "",
      companyName: "",
      productId: 0,
      companyProducts: [],
      productsKeywords: [],
    };
  },
  methods: {
     handleLoad() {
      this.imageCount++;
      if (this.imageCount == this.otherProducts.length) {
        this.isLoading = false;
      }
    },
    changeProductView(id) {
      this.showLoader = true;
      var temp = [];
      var index = 1;
      var lastIndexBeforeTarget = 0;
      this.companyProducts.forEach((ele) => {
        if (ele.id == id) {
          index = 0;
          this.productName = ele.fullTitle;
          this.productImage = ele.image;
        }

        temp.push({
          index: index,
          id: ele.id,
          image: ele.image,
          title: ele.title,
          fullTitle: ele.fullTitle,
          description: ele.description,
          productLink: ele.productLink,
        });

        if (index == 0) {
          index = lastIndexBeforeTarget + 1;
        } else {
          index++;
        }
      });

      this.otherProducts = [];
      this.otherProducts = temp.filter((q) => q.id != id);

      var companyFirst3Words = this.companyName
        .split(" ")
        .slice(0, 3)
        .join(" ");

      window.scrollTo(0, 0);
      setTimeout(() => {
        this.showLoader = false;
        this.$store.state.detailsTitleX =
          `${this.productName} ${companyFirst3Words}`.substr(0, 70);
        this.$store.state.detailsDescriptionX = `${this.productName} ${this.companyName} ${this.countryName}`;
      }, 250);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
    async getCompanyProducts() {
      var companies = [this.$store.state.singleCompanyIdX];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyProducts = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullProductsX = this.companyProducts;
      this.buildCompanyProducts(this.companyProducts);
    },
    buildCompanyProducts(variable) {
      var temp = [];
      if (variable.length > 0) {
        variable = variable[0].Products;

        variable.forEach((product) => {
          if (product.Images.length > 0) {
            var productId = parseInt(product._id);
            
            product.Images.forEach((pImage) => {              
              var image = pImage.Image;
              var id = parseInt(pImage._id);
              var title =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Name
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Name;

              var fullTitle = title;
              title = title.length > 15 ? `${title.substr(0, 15)}...` : title;

              var description =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Description
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Description;

              var keywords =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Keywords
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Keywords;

              if (keywords != "" && keywords != undefined) {
                keywords.split(",").forEach((k) => {
                  this.productsKeywords.push(k);
                });
              }

              var productLink = `${fullTitle
                .toLowerCase()
                .trim()
                .split(" ")
                .join("-")}-${id}`;

              productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
              productLink = productLink.replace(/---/g, "-");
              productLink = productLink.replace(/--/g, "-");

              temp.push({
                productId: productId,
                id: id,
                image: image,
                title: title,
                fullTitle: fullTitle,
                description: description,
                productLink: productLink,
              });
            });
          }
        });

        this.companyProducts = [];
        this.companyProducts = temp;

        this.productName = this.companyProducts.filter(
          (q) => q.id == this.productId || q.productId == this.productId
        )[0].fullTitle;

        this.productImage = this.companyProducts.filter(
          (q) => q.id == this.productId || q.productId == this.productId
        )[0].image;

        this.otherProducts = this.companyProducts.filter(
          (q) => q.id != this.productId || q.productId == this.productId
        );

        var companyFirst3Words = this.companyName
          .split(" ")
          .slice(0, 3)
          .join(" ");

        this.$store.state.detailsTitleX =
          `${this.productName} ${companyFirst3Words}`.substr(0, 70);
        this.$store.state.detailsDescriptionX = `${this.productName} ${this.companyName} ${this.countryName}`;
      }

      this.showLoader = false;
    },
  },
  mounted() {
    this.showLoader = true;

    this.scrollToTop();
    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.countryName =
      this.$store.state.singleCompanyDetailsX.Country.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.productId = helper.getProductId(this.$route.params.id);

    if (this.$store.state.singleCompanyFullProductsX.length == 0) {
      this.getCompanyProducts();
    } else {
      this.buildCompanyProducts(this.$store.state.singleCompanyFullProductsX);
    }

    if (this.$store.state.singleCompanyProductIdX > 0) {
      this.changeProductView(this.$store.state.singleCompanyProductIdX);
      this.$store.state.singleCompanyProductIdX = 0;
    }
  },
};
</script>

<style scoped>
.detail-product-item-title-box {
  margin-top: 24px;
  margin-bottom: 24px;
}
.detail-product-item-title-box > h6 {
  font-family: DM Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  display: flex;
  align-items: center;
  color: var(--m3--sys--light--on-surface);
  margin: 0;
}
.product-list > h1 {
  font-family: DM Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  font-feature-settings: "liga" off;
  color: var(--m3--sys--light--on-surface);
  margin: 0;
}
.product-list > div > img {
  height: auto;
  display: flex;
  margin: 0 auto;
  max-height: 500px;
}
.page-laoder {
  position: fixed !important;
  background-color: transparent !important;
  top: 50%;
}
.loading {
  background-image: url(https://www.forie.com/img/b-lazy-loading.gif);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 200%;
   height: 260px;
  z-index: 999999 !important;
}
</style>
